module.exports = __webpack_public_path__ + "img/pick_spec.fb66fa81.svg";